import React from 'react';

export interface Props {
    text?: string | undefined;
    words?: number;
    textLength?: number;
    children?: (text: string) => React.ReactNode;
}

class TextShortener extends React.Component<Props> {
    render() {
        let { text } = this.props;
        let textShortened = false;
        const { children } = this.props;

        if (text === null || text === undefined) {
            return null;
        }

        if (this.props.textLength) {
            if (text.length > this.props.textLength!) {
                textShortened = true;
                text = text.slice(0, this.props.textLength);
            }
        }

        if (this.props.words) {
            const split = text.split(' ');

            // When text is the right length and has the right amount of words, return and dont add '...' at the end
            if (split.length <= this.props.words && !textShortened) {
                return (children && children(text)) || text;
            }
            split.splice(-(split.length - this.props.words), split.length - this.props.words);
            return (children && children(`${split.join(' ') + '...'}`)) || `${split.join(' ') + '...'}`;
        }

        // Text is correct dont add '...' at the end
        if (!textShortened) {
            return (children && children(text)) || text;
        }

        return (children && children(`${text}...`)) || `${text}...`;
    }
}

export default TextShortener;
